export default __webpack_public_path__ + "static/media/12.f9571fb7.png";